module.exports = __webpack_public_path__ + "static/img/bg_mod_city.ac449dda.jpg";